<!-- <app-add-product-crousel-cust></app-add-product-crousel-cust> -->

<div class="roles">
  <div class="container">
    <div class="roles__main-card">
      <img loading="lazy" src="../../../../assets/images/profile-charactor/compressed/man.jpeg" alt="" />
      <div>
        <div class="name">Wizard Welcome,</div>
        <div class="desc">
          Provide your services to the community and earn a pay while also gaining the respect and appreciation of your neighbours. Below are a few of the common roles that you can become.
          <br />
          - Some roles require certification to be uploaded and verified
        </div>
      </div>
    </div>
    <div class="roles__grid">
      <div *ngFor="let item of roles" class="roles__card">
        <img loading="lazy" (click)="openRoleModal(roleModal, item)" src="../../../../assets/images/profile-charactor/compressed/{{ item.image }}" [alt]="item.title" />
        <div class="name" (click)="openRoleModal(roleModal, item)">
          {{ item.title }}
          <span
            class="name__badge"
            [ngClass]="{
              certified: item.status === 'Certified',
              pending: item.status === 'Pending'
            }"
            *ngIf="item.status != 'Join'"
          >
            {{ item.status }}
          </span>
        </div>
        <div class="desc">
          {{ item.open ? item.desc : item.desc.substr(0, 100)
          }}<span (click)="item.open = !item.open" *ngIf="item.desc.length > 100">
            <span class="read">{{ item.open ? " Read Less" : " ...Read More" }}</span></span
          >
        </div>
        <div>
          <button
            class="button-2"
            [ngClass]="{
              certified: item.status === 'Certified',
              pending: item.status === 'Pending'
            }"
            (click)="item.status == 'Join' ? handleChooseRole(uploadCertificate, item) : ''"
          >
            {{ item.status }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #uploadCertificate let-modal>
    <div id="forum_form_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
          <h5 class="text-center">Upload Your Certification</h5>
          <div class="form-group">
            <label for="">Organization</label>
            <input type="text" class="form-control" placeholder="Organization" formControlName="organization" />
            <div class="text-danger" *ngIf="myForm.get('organization').invalid && myForm.get('organization').touched">Organization is required</div>
          </div>
          <div class="form-group">
            <label for="">Certified For</label>
            <input type="text" class="form-control" placeholder="Certified For" formControlName="certifiedFor" />
            <div class="text-danger" *ngIf="myForm.get('certifiedFor').invalid && myForm.get('certifiedFor').touched">Certified is required</div>
          </div>
          <div class="form-group">
            <label for="">Upload File</label>
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" class="custom-file-input" (change)="onFileChange($event)" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" />
                <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger mr-2" (click)="modalService.dismissAll()"><i class="fa-solid fa-times"></i> Cancel</button>
          <button class="btn btn-primary" [disabled]="myForm.invalid"><i class="fa-solid fa-paper-plane"></i> Submit</button>
        </div>
      </form>
    </div>
  </ng-template>
</div>

<ng-template #roleModal let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <!-- <h2 class="title">{{ role.title }}</h2> -->
    <div class="modal-card">
      <img src="../../../../assets/images/profile-charactor/compressed/{{ role.image }}" [alt]="role.title" />
      <div class="name" (click)="openRoleModal(roleModal, item)">
        {{ role.title }}
        <span
          class="name__badge"
          [ngClass]="{
            certified: role.status === 'Certified',
            pending: role.status === 'Pending'
          }"
          *ngIf="role.status != 'Join'"
        >
          {{ role.status }}
        </span>
      </div>
      <div class="desc">
        {{ role.desc }}
      </div>
      <button
        class="button-2"
        [ngClass]="{
          certified: role.status === 'Certified',
          pending: role.status === 'Pending'
        }"
        (click)="role.status == 'Join' ? handleChooseRole(uploadCertificate, role) : ''"
      >
        {{ role.status }}
      </button>
    </div>
  </div>
</ng-template>
